import { DateTime } from "luxon";
import { DebtDistribution } from "./DeptDistribution";
import { getRatingRange } from "./getRatingRange";
import { UserAuthDataBalanceAccount } from "../../../../backendApi/amplifyGraphQl/CustomGetUserData/UserData";
import { calculateDiffYears } from "@goodfill/date";
import { PricedBond } from "../../../../bonds/PricedBond";
import { getBondRatingIndex } from "../../../../bonds/bondRating/getBondRatingIndex";

export type BondForPortfolioDeptDistribution = Pick<PricedBond, "ratings" | "bondIdCusip" | "maturityDate">;

export interface AccountBondHoldingForDeptDistribution {
  pricedBond: BondForPortfolioDeptDistribution;
  bondBalanceAccount: Pick<UserAuthDataBalanceAccount, "balance">;
}

export function createPortfolioDeptDistribution(
  bondHoldings: AccountBondHoldingForDeptDistribution[],
  tradeDate: DateTime,
): DebtDistribution {
  const result: DebtDistribution = [];

  bondHoldings.forEach((bondHolding) => {
    if (bondHolding.bondBalanceAccount.balance.lessThanOrEqualTo(0)) {
      return;
    }

    const bond = bondHolding.pricedBond;
    const { moodysIndex, spIndex } = getBondRatingIndex(bond);

    const diffYears = calculateDiffYears(bond.maturityDate, tradeDate);

    const existingRatingIndices = [spIndex, moodysIndex].filter((a) => a >= 0);

    result.push({
      ratingRangeId: getRatingRange(Math.min(...existingRatingIndices)),
      maturityYears: Math.ceil(diffYears),
      faceAmount: bondHolding.bondBalanceAccount.balance,
    });
  });

  return result;
}
